module.exports = __webpack_public_path__ + "img/banner-ru-d.82e3a63.webp";